import { TAssetBatch } from "shared/types/assetExporter";

export const getAssetBatchById = (
  assetBatches: TAssetBatch[],
  assetBatchId?: string,
) => assetBatches.find(assetBatch => assetBatch.assetBatchId === assetBatchId);
